import { gql } from '@apollo/client';

const Fragments = {
  requiredDocumentsItem: gql`
    fragment requiredDocumentsItem on RequiredDocument {
      requiredDocTypeId
      documentCode
      documentName
      sharePointContentType
    }
  `
};

export default Fragments;
